import { navigate } from "../../lib/route";

// Reusable dashboard primitives. StatCard is a stats tile (number + label),
// NextStepCard is a CTA tile used by the GettingStartedGuide checklist.

export function StatCard({
  title,
  value,
  sub,
  href,
}: {
  title: string;
  value: number | string;
  sub?: string;
  href?: string;
}) {
  const inner = (
    <div
      className="card"
      style={{
        textDecoration: "none",
        color: "inherit",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: "96px",
      }}
    >
      <h3
        style={{
          marginTop: 0,
          marginBottom: "0.25rem",
          fontSize: "0.875rem",
          color: "var(--muted)",
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
        }}
      >
        {title}
      </h3>
      <div style={{ fontSize: "2.25rem", fontWeight: 700, lineHeight: 1, flex: 1 }}>{value}</div>
      {sub && (
        <p style={{ margin: "0.35rem 0 0", color: "var(--muted)", fontSize: "0.8rem" }}>
          {sub}
        </p>
      )}
    </div>
  );
  if (href) return <a href={href} style={{ textDecoration: "none", display: "block", height: "100%" }}>{inner}</a>;
  return inner;
}



export function NextStepCard({
  icon,
  title,
  description,
  cta,
  href,
  done,
}: {
  icon: string;
  title: string;
  description: string;
  cta: string;
  href: string;
  done?: boolean;
}) {
  return (
    <a
      href={href}
      style={{ textDecoration: "none" }}
      onClick={(e) => {
        e.preventDefault();
        navigate(href.replace("#", ""));
      }}
    >
      <div
        className="card"
        style={{
          display: "flex",
          gap: "1rem",
          alignItems: "flex-start",
          opacity: done ? 0.5 : 1,
          borderLeft: done ? "3px solid var(--accent)" : "3px solid var(--border)",
          transition: "border-color 0.15s",
        }}
      >
        <span style={{ fontSize: "1.75rem", lineHeight: 1, flexShrink: 0 }}>{icon}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <strong style={{ fontSize: "1rem" }}>{title}</strong>
            {done && (
              <span
                style={{
                  background: "var(--accent)",
                  color: "white",
                  fontSize: "0.7rem",
                  padding: "0.1rem 0.4rem",
                  borderRadius: 999,
                  fontWeight: 600,
                }}
              >
                done
              </span>
            )}
          </div>
          <p style={{ margin: "0.25rem 0 0.5rem", color: "var(--muted)", fontSize: "0.875rem" }}>
            {description}
          </p>
          {!done && (
            <span style={{ color: "var(--accent)", fontSize: "0.875rem", fontWeight: 500 }}>
              {cta} →
            </span>
          )}
        </div>
      </div>
    </a>
  );
}

